import React from 'react';
import breakpoints from '@repo/ui-components/breakpoints';
import styled from 'styled-components';
import IconFacebook from '../svgs/fb.svg';
import IconInstagram from '../svgs/instagram.svg';
import IconYoutube from '../svgs/yt.svg';

const iconHeight = 42;

const SocialIconsContainer = styled.div`
  display: flex;
`;

const SocialLink = styled.a`
  height: ${iconHeight}px;
  width: ${iconHeight}px;
  margin: 0 1.5vw;
  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    margin-left: 0;
    margin-right: 0.5vw;
  }

  img {
    max-height: 100%;
  }
`;

const FacebookIcon = styled(IconFacebook)``;

const InstagramIcon = styled(IconInstagram)``;

const YoutubeIcon = styled(IconYoutube)``;

function SocialIcons() {
  return (
    <SocialIconsContainer>
      <SocialLink
        href="https://www.facebook.com/sportdogbrand"
        rel="noopener noreferrer"
        target="_blank"
      >
        <FacebookIcon
          width={iconHeight}
          alt="Facebook Icon"
          height={iconHeight}
        />
      </SocialLink>
      <SocialLink
        href="https://www.instagram.com/sportdog/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <InstagramIcon
          width={iconHeight}
          alt="Instagram Icon"
          height={iconHeight}
        />
      </SocialLink>
      <SocialLink
        href="https://www.youtube.com/user/sportdogbrand/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <YoutubeIcon
          width={iconHeight}
          alt="Youtube Icon"
          height={iconHeight}
        />
      </SocialLink>
    </SocialIconsContainer>
  );
}

export default SocialIcons;
